import axios from "axios";

import { ApiElementsResponse, ApiFile, ApiFragmentNode } from "../shared/interfaces";
import { FileWithPath } from "react-dropzone";
import { FileUploader, UploadProgressCallback } from "../util/FileUploader";

export const FileApi = {
    getFile: async (id: string): Promise<ApiFile> => {
        const resp = await axios.get(`/api/file/${id}`);
        return resp.data;
    },

    getFragmentNode: async (id: string): Promise<ApiFragmentNode> => {
        const resp = await axios.get(`/api/fragmentNode/${id}`);
        return resp.data;
    },

    getFileElements: async (id: string, page: number): Promise<ApiElementsResponse> => {
        const resp = await axios.get(`/api/file/${id}/elements`, {
            params: { page },
        });
        return resp.data;
    },

    getAllFiles: async (): Promise<ApiFile[]> => {
        const resp = await axios.get("/api/file");
        return resp.data;
    },

    uploadFile: async (
        file: FileWithPath,
        onProgress?: UploadProgressCallback,
    ): Promise<ApiFile> => {
        return FileUploader.uploadFile(file, onProgress);
    },

    getRelatedFragmentNodes: async (
        id: string,
        fragmentUuid: string,
    ): Promise<ApiFragmentNode[]> => {
        const resp = await axios.get(`/api/file/${id}/relatedFragmentNodes`, {
            params: { fragmentUuid },
        });
        return resp.data;
    },
};
